(function () {
    "use strict";

    var siteBuilder = require('./builder.js');
    var publisher = require('../vendor/publisher');
    require('jquery-hoverintent')($);

    /*
        constructor function for Element
    */
    module.exports.Element = function (el) {
                
        this.element = el;
        this.sandbox = false;
        this.parentFrame = {};
        this.parentBlock = {};//reference to the parent block element
        this.editableAttributes = [];
        
        //make current element active/open (being worked on)
        this.setOpen = function() {
            
            $(this.element).off('mouseenter mouseleave');
                                            
            //$(this.element).css({'outline': '2px solid rgba(233,94,94,0.5)', 'outline-offset':'-2px', 'cursor': 'pointer'});

            this.element.classList.add('sb_open');
            this.element.classList.remove('sb_hover');
            
        };
        
        //sets up hover and click events, making the element active on the canvas
        this.activate = function() {
            
            var element = this,
                DELAY = 700, clicks = 0, timer = null;

            //data attributes for color
            if ( this.element.tagName === 'A' ) $(this.element).data('color', getComputedStyle(this.element).color);
            
            $(this.element).css({'outline': '', 'cursor': ''});

            $(this.element).off('click').off('dbclick').hoverIntent({
                over: function (e) {

                    e.stopPropagation();

                    if ( !this.hasAttribute('data-nointent') ) {

                        //$(this).css({'outline': '2px solid rgba(233,94,94,0.5)', 'outline-offset': '-2px', 'cursor': 'pointer'});
                        this.classList.add('sb_hover');

                    }

                },
                out: function (e) {

                    e.stopPropagation();

                    //$(this).css({'outline': '', 'cursor': '', 'outline-offset': ''});
                    this.classList.remove('sb_hover');

                }
            }).on('mouseenter', function () {

                if ( $(this).parents('*[data-selector]')[0] ) $(this).parents('*[data-selector]')[0].setAttribute('data-nointent', true);

                //de-select all canvas elements first
                publisher.publish('onHoverCanvasElement', element);

            }).on('mouseleave', function () {

                if ( $(this).parents('*[data-selector]')[0] ) $(this).parents('*[data-selector]')[0].removeAttribute('data-nointent');

            }).on('click', function (e) {

                e.preventDefault();
                e.stopPropagation();

                if ( element.element.classList.contains('sb_open') ) return false;
                
                //element.clickHandler(this);

                clicks++;  //count clicks

                if(clicks === 1) {

                    timer = setTimeout(function() {

                        if ( !element.element.classList.contains('sb_open') && !element.element.classList.contains('medium-editor-element') ) element.clickHandler(this);   
                        clicks = 0;

                    }, DELAY);

                } else {

                    clearTimeout(timer);
                    element.dblClickHandler(this);   
                    clicks = 0;
                }

            }).on('dblclick', function (e) {

                e.preventDefault();

            });
            
        };
        
        this.deactivate = function() {
            
            $(this.element).off('mouseenter mouseleave click');
            //$(this.element).css({'outline': '', 'cursor': ''});
            this.element.classList.remove('sb_open');
            this.element.classList.remove('sb_hover');

        };
        
        //removes the elements outline
        this.removeOutline = function() {
            
            //$(this.element).css({'outline': '', 'cursor': ''});

            this.element.classList.remove('sb_open');
            this.element.classList.remove('sb_hover');

        };

        this.unsetNoIntent = function () {

            this.element.removeAttribute('data-nointent');

        };
        
        //sets the parent iframe
        this.setParentFrame = function() {
            
            var doc = this.element.ownerDocument;
            var w = doc.defaultView || doc.parentWindow;
            var frames = w.parent.document.getElementsByTagName('iframe');
            
            for (var i= frames.length; i-->0;) {
                
                var frame= frames[i];
                
                try {
                    var d= frame.contentDocument || frame.contentWindow.document;
                    if (d===doc)
                        this.parentFrame = frame;
                } catch(e) {}
            }
            
        };
        
        //sets this element's parent block reference
        this.setParentBlock = function() {
            
            //loop through all the blocks on the canvas
            for( var i = 0; i < siteBuilder.site.sitePages.length; i++ ) {
                                
                for( var x = 0; x < siteBuilder.site.sitePages[i].blocks.length; x++ ) {
                                        
                    //if the block's frame matches this element's parent frame
                    if( siteBuilder.site.sitePages[i].blocks[x].frame === this.parentFrame ) {
                        //create a reference to that block and store it in this.parentBlock
                        this.parentBlock = siteBuilder.site.sitePages[i].blocks[x];
                    }
                
                }
                
            }
                        
        };
        
        
        this.setParentFrame();
        
        /*
            is this block sandboxed?
        */
        
        if( this.parentFrame.getAttribute('data-sandbox') ) {
            this.sandbox = this.parentFrame.getAttribute('data-sandbox');   
        }
                
    };

}());


//////////////////
// WEBPACK FOOTER
// ./assets/js/modules/canvasElement.js
// module id = 86
// module chunks = 1 2